import store from '../index'
import menuMap from './menu'
const usePermissionStore= ({
    state: {
        menu_list: {
            "tab1": {},
            "tab2": {},
            "tab3": {},
        },

        menuMap: {
            "tab1":
                // ["TestingApplication", "SampleInformation", "ReportPackageRecord", "ReturningSamples", "ReturningSamplesRecord", "ExpressManagement",
                // "CompoundQuery", "ReportQuery", "SampleBoxApplication", "SampleBoxRecord", "BarcodeDatabase", "BasicInformation", "User",
                // "RightsManage", "SubmissionDepartment", "SubmissionPhysicians",],
                [2007, 2008, 2009, 2011, 2012, 2013, 2016, 0, 0, 0, 0, 2021, 2022, 2023, 2024, 2025,],
            "tab2":
                // ["DepartmentInformation", "UserManage", "Roles", "TestBase", "TestProjects", "ProjectSeries", "SampleType", "Agent",
                // "Hospital", "SampleBoxApplicationInfo", "BarcodeLibrary", "ReturnBagInfo", "SubjectSampleInfo", "SampleHandoverForm",
                // "GeneticDataImport", "ReportFileUpload", "ReportRegeneration", "ScanCodeImport", "ComQuery",
                // "MonthlyStatistics", "ReportQuery",],
                [1007, 1008, 1009, 1010, 1011, 1012, 1013, 1015, 1016, 0, 1020, 1021, 1022, 0, 1023, 1024, 1025, 0, 1031, 0, 0, 0, 1026, 1027],

            "tab3":
                // ["TestingApplication", "SampleInformation", "ReportPackageRecord", "ReturningSamples", "ReturningSamplesRecord", "ExpressManagement",
                // "CompoundQuery", "ReportQuery", "SampleBoxApplication", "SampleBoxRecord", "BarcodeDatabase", "BasicInformation", "User",
                // "RightsManage", "SubmissionDepartment", "SubmissionPhysicians",],
                [3007, 3008, 3009, 3011, 3012, 3013, 3016, 0, 0, 0, 0, 3021, 3022, 3023, 3024, 3025,],
        },
        buttonMap:
            // ["add", "delete", "edit", "query"]
            [1, 2, 3, 4, 5]
    },
    mutations: {
        get_tab1_menu_list() {
            console.log("store.state.user_role ", store.state.user_role)
            for(let item of store.state.user_role.menu) {
                console.log("item ", item)
                for (let menuName of usePermissionStore.state.menuMap.tab1) {
                    if (item === menuName)
                        usePermissionStore.state.menu_list["tab1"][menuName] = true
                    // else
                    //     usePermissionStore.state.menu_list["tab1"][menuName] = false
                    }

            }
            console.log("usePermissionStore.state ", usePermissionStore.state)
        },

        judge_role_menu(tab, index){
            let name = "name"
            if(tab === 1)
                name = usePermissionStore.state.menuMap.tab1[index]
            else if(tab === 2)
                name = usePermissionStore.state.menuMap.tab2[index]
            else if(tab === 3)
                name = usePermissionStore.state.menuMap.tab3[index]

            for(let item of store.state.user_role.menu)
            {
                if(item === name) {
                    // console.log("name ", name)
                    return true
                }
            }
            return false
        },

        judge_role_button(index){
            for (let item of store.state.user_role.button)
            {
                if(item === usePermissionStore.state.buttonMap[index])
                    return true
            }
            return false
        },

    },
    actions: {}
})

export default usePermissionStore;